import { PiggyBank, TrendingUp, Timer } from "lucide-react";
import Reveal from "@/components/Reveal";
import pattern60 from "@/assets/pattern-60.svg";
import pattern10x from "@/assets/pattern-10x.svg";
import pattern90 from "@/assets/pattern-90.svg";

const stats = [
  {
    icon: PiggyBank,
    value: "60%",
    label: "Lower production cost vs. traditional",
    desc: "Remove studio, model, and revision overhead.",
    pattern: pattern60,
  },
  {
    icon: TrendingUp,
    value: "10x",
    label: "Faster from idea → first ready ad",
    desc: "Go from concept to ready to publish assets in minutes.",
    pattern: pattern10x,
  },
  {
    icon: Timer,
    value: "90%",
    label: "Less time spent on production",
    desc: "Generate model shoots, variations, and videos instantly.",
    pattern: pattern90,
  },
];

interface SocialProofProps {
  heading?: string;
  description?: string;
}

const SocialProof = ({
  heading = "Trusted by 5000+ companies worldwide",
  description = "Pixro.AI Fashion is an all-in-one fashion AI platform for designers, fashion brands, and creative agencies, uniting design, visualization, and commerce in a single workflow.",
}: SocialProofProps = {}) => {
  return (
    <section id="social-proof" className="py-16 sm:py-24 bg-card">
      <div className="container mx-auto px-6 sm:px-8 md:px-[10%]">
        <Reveal variant="fade-up">
          <h2 className="text-3xl font-bold text-foreground sm:text-4xl md:text-5xl">
            {heading}
          </h2>
          <p className="mt-4 max-w-4xl text-muted-foreground leading-relaxed text-sm sm:text-base">
            {description}
          </p>
        </Reveal>

        <div className="mt-10 sm:mt-12 grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          {stats.map((stat, i) => (
            <Reveal key={stat.value} variant="fade-up" delay={i * 120}>
              <div className="relative rounded-2xl border border-border bg-secondary/50 p-6 sm:p-8 pb-8 sm:pb-10 overflow-hidden h-full">
                <img
                  src={stat.pattern}
                  alt=""
                  role="presentation"
                  aria-hidden="true"
                  className="absolute top-0 right-0 h-full object-contain object-right-top pointer-events-none"
                />

                {/* Icon circle */}
                <div className="relative z-10 mb-5 sm:mb-6 flex h-24 w-24 sm:h-32 sm:w-32 items-center justify-center rounded-full bg-muted">
                  <stat.icon className="h-10 w-10 sm:h-12 sm:w-12 text-primary" strokeWidth={1.5} />
                </div>

                {/* Stats */}
                <div className="relative z-10">
                  <p className="text-4xl sm:text-5xl text-primary font-extrabold">{stat.value}</p>
                  <p className="mt-2 text-base font-medium text-foreground">{stat.label}</p>
                  <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{stat.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

      </div>
    </section>
  );
};

export default SocialProof;
